import { IEmployment } from "@/types/employment";
import { MasterData } from "./masterData";

export class Employment extends MasterData implements IEmployment {
  public readonly company_id = 0;
}
